import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-manage-staff',
		path: '/dashboard/manage_staff',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_manage_staff" */ './index'), {
			exportName: 'AdminManageStaff',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staffAdmin',
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
